module.exports = __webpack_public_path__ + "static/img/no3_bg.414ae90c.png";